import {useState, useEffect} from 'react'

export default function useStateDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const [realValue, setRealValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(realValue)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
    // eslint-disable-next-line
  }, [realValue, setDebouncedValue])

  return [debouncedValue, setRealValue, realValue]
}
